/**
 * This is a hack, to make the imports for all apps appear uniform
 * when viewed in client/index.tsx.
 *
 * The pages should probably be moved to
 * apps/courses/* or apps/courses/pages* at some point.
 */
export * from './pages';
